import RawSharedBasic from "./RawSharedBasic";
import { ModalProp } from "@/types";

const BaseusOrderRequestDataInfo: ModalProp[] = [
  {
    key: "poNo",
    label: "PO No",
  },
  {
    key: "platform",
    label: "Platform",
  },
  {
    key: "stockType",
    label: "Stock Type",
  },
  {
    key: "userRemark",
    label: "User Remark",
  },
  {
    key: "warehouseCode",
    label: "Warehouse Code",
  },
  {
    key: "customerNumber",
    label: "Customer Number",
  },
  {
    key: "shipmentMethod",
    label: "Shipment Method",
  },
  {
    key: "isCustomerDeliver",
    label: "Is Customer Deliver",
  },
  {
    key: "platform",
    label: "Platform",
  },
  {
    key: "stockType",
    label: "Stock Type",
  },
  {
    key: "userRemark",
    label: "User Remark",
  },
  {
    key: "warehouseCode",
    label: "Warehouse Code",
  },
  {
    key: "customerNumber",
    label: "Customer Number",
  },
  {
    key: "shipmentMethod",
    label: "Shipment Method",
  },
  {
    key: "isCustomerDeliver",
    label: "Is Customer Deliver",
  },
];

interface BaseusOrderRequestRawProps {
  rawData: Record<string, unknown>;
  className?: string;
  labelStyle?: React.CSSProperties;
  contentStyle?: React.CSSProperties;
}

export const BaseusOrderRequestRaw = (props: BaseusOrderRequestRawProps) => {
  const { rawData, className, labelStyle, contentStyle } = props;
  return (
    <RawSharedBasic
      rawData={rawData}
      dataProps={BaseusOrderRequestDataInfo}
      className={className}
      labelStyle={labelStyle}
      contentStyle={contentStyle}
    />
  );
};
